// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"213":"f316acf7","667":"7750d6ad"}[chunkId] + ".chunk.js");